import * as Types from '../../graphql/generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StartInvoiceRunMutationVariables = Types.Exact<{
  type: Types.InvoiceRunType;
  year: Types.Scalars['Int'];
  iso_month: Types.Scalars['Int'];
  dry_run?: Types.InputMaybe<Types.Scalars['Boolean']>;
  next_es_invoice_number?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type StartInvoiceRunMutation = { __typename?: 'Mutation', startInvoiceRun: { __typename?: 'InvoiceRun', id: string, status: Types.InvoiceRunStatus, due_at?: string | null } };


export const StartInvoiceRunDocument = gql`
    mutation StartInvoiceRun($type: InvoiceRunType!, $year: Int!, $iso_month: Int!, $dry_run: Boolean, $next_es_invoice_number: Int) {
  startInvoiceRun(
    type: $type
    year: $year
    iso_month: $iso_month
    dry_run: $dry_run
    next_es_invoice_number: $next_es_invoice_number
  ) {
    id
    status
    due_at
  }
}
    `;
export type StartInvoiceRunMutationFn = Apollo.MutationFunction<StartInvoiceRunMutation, StartInvoiceRunMutationVariables>;

/**
 * __useStartInvoiceRunMutation__
 *
 * To run a mutation, you first call `useStartInvoiceRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartInvoiceRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startInvoiceRunMutation, { data, loading, error }] = useStartInvoiceRunMutation({
 *   variables: {
 *      type: // value for 'type'
 *      year: // value for 'year'
 *      iso_month: // value for 'iso_month'
 *      dry_run: // value for 'dry_run'
 *      next_es_invoice_number: // value for 'next_es_invoice_number'
 *   },
 * });
 */
export function useStartInvoiceRunMutation(baseOptions?: Apollo.MutationHookOptions<StartInvoiceRunMutation, StartInvoiceRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartInvoiceRunMutation, StartInvoiceRunMutationVariables>(StartInvoiceRunDocument, options);
      }
export type StartInvoiceRunMutationHookResult = ReturnType<typeof useStartInvoiceRunMutation>;
export type StartInvoiceRunMutationResult = Apollo.MutationResult<StartInvoiceRunMutation>;
export type StartInvoiceRunMutationOptions = Apollo.BaseMutationOptions<StartInvoiceRunMutation, StartInvoiceRunMutationVariables>;